/** Types shared across OrionIQ agent surfaces (e.g. builder chat, general agent), not specific to the builder endpoint contract. */
export var UsagePerformanceDashboardView;
(function (UsagePerformanceDashboardView) {
    UsagePerformanceDashboardView["AiAgents"] = "ai-agents";
    UsagePerformanceDashboardView["AiChat"] = "ai-chat";
})(UsagePerformanceDashboardView || (UsagePerformanceDashboardView = {}));
//# sourceMappingURL=agent-common.types.js.map